(ns com.github.tamaikisage.arzulari-yogunlashtir.routes
  (:require [com.github.tamaikisage.arzulari-yogunlashtir.components :refer [link sihirli-kart img-with-caption inline-emphasis]]
            [com.github.tamaikisage.arzulari-yogunlashtir.data :refer [alt-magical-card-list-data home-page-image-list-data about-page-image-list-data my-email]]))

(declare about-me-route)

(defn home-page-images []
  [:<>
   (map (fn [data]
          (into [img-with-caption] data)) (take 3 home-page-image-list-data))])

(defn- home []
  (println (home-page-images))
  [:div.home-page
   [:h2 "Hypnotic Desires, You Say?"]
   [home-page-images]
   [:div.content-holder
    [:h2 "I can turn them real."]
    [:p "Imagine yourself in any of these scenes. Take a moment, pick one."]
    [:p "Is it as one of the girls? One of the males?"]
    [:p "It might even be as an extradimensional force being involved in these wickedly beautiful scenes..."]
    [:p "You'll notice, that whether you met me wittingly or not, you like more things than you did before meeting me."]
    [:p.the-force-that-makes-it-real "But what's more important? You'll notice " [inline-emphasis "your roleplay experiences turn real."]]]
   (into [img-with-caption] (get home-page-image-list-data 3))
   [:div.content-holder
    [:p "\"...Turn real? As in, I'll experience these things, as if they're happening to me in real life???\""]
    [:p "We'll see. But mhm.~  And clearly, that's one way I'm different from your other roleplay partners."]
    [:p "What's more, just imagine, after meeting me, every time you roleplay with someone, the scenes all just feel more real."]
    [:p "Every scene has you feel like you're stepping into them."]
    [:p "Imagine, always having the impression of experiencing your roleplays, directly with a body you've chosen, or one chosen for you,"]
    [:p "And then experiencing more than the words alone convey."]]
   (into [img-with-caption] (get home-page-image-list-data 4))
   [:div.content-holder
    [:p "What do tentacles feel like? What does it feel like to be injected with drugs that drive your stimulation and sensitivity by a thousand, or a million times?"]
    [:p "You have a much better idea now."]
    [:p "You know what it's like to be a little whore."]
    [:p "Or to be a happy cuck."]]
   (into [img-with-caption] (get home-page-image-list-data 5))
   [:div.content-holder
    [:p "Or a breeding bull. Or a Demon Lord."]
    [:p "Which scenario would you like?"]
    [:p "You will need to give me free reign to put you across ones at my discretion."]
    [:p "But even you can find that reasonable. Because I'm a force of perversion, as you know."]
    [:p "Now then... how do I make these things happen for you?"]
    [:div.read-all-about-it [link (assoc-in about-me-route [1 :label] "Read All About It")]]]])

(defn about-page-image [index] (into [img-with-caption] (get about-page-image-list-data index)))

(defn- about []
  [:div.about-page
   [:h2 "So how do your roleplay adventures turn real?"]
   (about-page-image 0)
   [:div.content-holder
    [:p "The gif should make one thing clear. It's seamless enough that our interactions are through text alone"]
    [:p "But now you're wondering, how exactly would that work?"]
    [:p "For you to gain surreal experiences, and even a permanent ability to experience pleasure?"]
    [:p "But you needn't worry; because it isn't just wordplay."]]
   [:h2 "So what exactly do we do?"]
   (about-page-image 1)
   [:div.content-holder
    [:p "You'll first have to get yourself comfortable with the idea of 'energy' (note: if you're familiar with 'cultivation' type stories, or are familiar with Eastern energy cultivation in general, this will be much more familiar)"]
    [:p "What does that mean? Energy? You've encountered that term so many times from spiritual talk. You cannot escape it. But hey, you're already well accustomed to it from anime aren't you?"]
    [:p "So just imagine, as people we all can produce energy. Chi, ki, prana, 'spiritual energy', no matter what we call it, we all have it."]
    [:p "That's not all. Energy can move and act by intention. So for instance, I can point my finger at your profile, and spend 10 - 20 minutes focusing on sending specific energy strains into your very being. All with the goal of affecting you."]
    [:p "Note that it doesn't matter where we are. We might as well be on North and South poles, or on opposite sides of the Earth along the Equator, or even on Moon and Mars - the point is, distance, does not really get in the way."]
    [:p "...Do you have to believe that? Hell no. You just need to humor me, and I have to try to be worth your time as well."]
    [:p "... So energy is sent. What happens next?"]
    [:p "It is possile that you'll notice the effects right away. You might feel calmer, you might feel more comfortable while talking to me. And yet..."]
    [:p "The real effect comes after. When I stimulate you by text. Such as, when I begin to describe a scene... you begin to notice how you actually can see and experience what I describe."]
    [:p "How clearly? We will have to see."]
    [:p "Consider me an artisan, perfecting my craft. Now that being the case, for anyone persisting, I think it's more than likely you'll see yourself experiencing something enjoyable, glad you've tried. And that being said, I don't intend for things to 'take long'."]]
   (about-page-image 2)
   [:div.content-holder
    [:p "You've probably checked the card pages already, haven't you? Saw foreign text, and that makes you wonder what it's all about..."]
    [:p "That's an intentional 'sneak peak' I've left to tease you, and make you wonder what it's all about. Sure, when you see yourself getting to know me, experiencing a little bit and then some... we'll have some fun talking about what's up there. For now, I'm keeping you posted."]]
   (about-page-image 3)
   [:div.content-holder
    [:p "And thus if you desire to always remain in contact with me, here's my email for you to keep: " [:a {:href (str "mailto:" my-email)} my-email]]]])

(defn- magical-card-page [title items]
  (let
   [listing (if (empty? items) [:p "No card items under this category available at this time, check back later and you might see something..."]
                (map (fn [[ad resim tanım]]
                       [sihirli-kart ad resim tanım]) items))]
    [:div.magical-card-page
     [:h2 title]
     [:div.kart-kabı
      listing]]))

(defn- magical-cards-alt []
  (magical-card-page "Magical Cards (Alternative!)" alt-magical-card-list-data))

(defn- magical-cards []
  (magical-card-page "Magical Cards (~General~)" []))

(defn not-found []
  [:div
   [:h2 "Page not found"]
   [:p "Check the link, perhaps try again later - but please make a Github issue if you strongly feel this is a genuine bug"]])

(def about-me-route ["/about" {:name :about :view about :label "About Me / The Methodology"}])
(def most-routes
  [["/" {:name :home :view home :label "Home"}]
   about-me-route
   ["/magical-cards/alt" {:name :magical-cards-alt :view magical-cards-alt :label "Magical Cards (Alt)"}]
   ["/magical-cards" {:name :magical-cards :view magical-cards :label "Magical Cards (General)"}]])
